import React from 'react'
import { Link } from "react-router-dom";


const HomeServices = () => {
  return (
    <>

      <div className="our-services light-section" style={{marginTop:"-40px"}}>
        <div className="container">
          <div className="row section-row align-items-end">
            <div className="col-xl-7">
              {/* Section Title Start */}
              <div className="section-title" style={{marginTop:"-40px"}}>
                <span className="section-sub-title wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Our Services</span>
                <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="Smart solar service designed for homes & businesses" style={{ perspective: 400 }}>
                  <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                    <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                      Smart Solar Service Designed For Homes & Businesses
                    </div>
                    </div>
                </h2>
              </div>
              {/* Section Title End */}
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 col-md-6">
              {/* Service Item Start */}
              <div className="service-item wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                <div className="service-item-image">
                  <figure>
                    <Link to="/solar-electrical-installation" data-cursor-text="View">
                      <img src="./assets/solar/Solar & Electrical Installation.webp" alt />
                    </Link>
                  </figure>
                  
                </div>
                <div className="service-item-body">
                  <div className="service-item-content">
                    <h2><Link to="/solar-electrical-installation">Solar & Electrical Installation</Link></h2>
                    <p>At Solar World Enterprises, we provide reliable, efficient, and cost-effective solar and electrical installation solutions for residential, commercial, and industrial needs. </p>
                  </div>
                  <div className="service-item-btn">
                    <Link to="/solar-electrical-installation" className="readmore-btn">Learn More</Link>
                  </div>
                </div>
              </div>
              {/* Service Item End */}
            </div>
            <div className="col-xl-4 col-md-6">
              {/* Service Item Start */}
              <div className="service-item wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                <div className="service-item-image">
                  <figure>
                    <Link to="/on-grid-off-grid-solar" data-cursor-text="View">
                      <img src="./assets/solar/On-Grid & Off-Grid Solar.webp" alt />
                    </Link>
                  </figure>
                  
                </div>
                <div className="service-item-body">
                  <div className="service-item-content">
                    <h2><Link to="/on-grid-off-grid-solar">On-Grid & Off-Grid Solar</Link></h2>
                    <p>At Solar World Enterprises, we provide advanced and reliable solar power solutions tailored to meet residential, commercial, and industrial energy needs. </p>
                  </div>
                  <div className="service-item-btn">
                    <Link to="/on-grid-off-grid-solar" className="readmore-btn">Learn More</Link>
                  </div>
                </div>
              </div>
              {/* Service Item End */}
            </div>
            <div className="col-xl-4 col-md-6">
              {/* Service Item Start */}
              <div className="service-item wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                <div className="service-item-image">
                  <figure>
                    <Link to="/solar-water-heater-solution" data-cursor-text="View">
                      <img src="./assets/solar/Services-Solar-Water-Heater.webp" alt />
                    </Link>
                  </figure>
                  
                </div>
                <div className="service-item-body">
                  <div className="service-item-content">
                    <h2><Link to="/solar-water-heater-solution">Solar Water Heater Solution</Link></h2>
                    <p>Harness the power of the sun and enjoy hot water all year round with Solar World Enterprises Solar Water Heater Solutions.</p>
                  </div>
                  <div className="service-item-btn">
                    <Link to="/solar-water-heater-solution" className="readmore-btn">Learn More</Link>
                  </div>
                </div>
              </div>
              {/* Service Item End */}
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 col-md-6">
              {/* Service Item Start */}
              <div className="service-item wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                <div className="service-item-image">
                  <figure>
                    <Link to="/hybrid-solar-power-plant" data-cursor-text="View">
                      <img src="./assets/images/service-item-image-1.jpg" alt />
                    </Link>
                  </figure>
                  
                </div>
                <div className="service-item-body">
                  <div className="service-item-content">
                    <h2><Link to="/hybrid-solar-power-plant">Hybrid Solar Power Plant</Link></h2>
                    <p>A Hybrid Solar Power Plant is an advanced energy solution that combines the benefits of solar power, battery storage, and grid connectivity to ensure uninterrupted electricity supply. </p>
                  </div>
                  <div className="service-item-btn">
                    <Link to="/hybrid-solar-power-plant" className="readmore-btn">Learn More</Link>
                  </div>
                </div>
              </div>
              {/* Service Item End */}
            </div>
            <div className="col-xl-4 col-md-6">
              {/* Service Item Start */}
              <div className="service-item wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                <div className="service-item-image">
                  <figure>
                    <Link to="/EV-charging-solution" data-cursor-text="View">
                      <img src="./assets/solar/EV Charging Solution.webp" alt />
                    </Link>
                  </figure>
                  
                </div>
                <div className="service-item-body">
                  <div className="service-item-content">
                    <h2><Link to="/EV-charging-solution">EV Charging Solution</Link></h2>
                    <p>As the world shifts towards clean and sustainable mobility, YoSolar World Enterprises brings you advanced and reliable EV Charging Solutions designed for homes, businesses, and commercial spaces.</p>
                  </div>
                  <div className="service-item-btn">
                    <Link to="/EV-charging-solution" className="readmore-btn">Learn More</Link>
                  </div>
                </div>
              </div>
              {/* Service Item End */}
            </div>
            <div className="col-xl-4 col-md-6">
              {/* Service Item Start */}
              <div className="service-item wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                <div className="service-item-image">
                  <figure>
                    <Link to="/solar-water-pump-solution" data-cursor-text="View">
                      <img src="./assets/solar/Solar Water Pump Solution.webp" alt />
                    </Link>
                  </figure>
                  
                </div>
                <div className="service-item-body">
                  <div className="service-item-content">
                    <h2><Link to="/solar-water-pump-solution">Solar Water Pump Solution</Link></h2>
                    <p>At Solar World Enterprises, we provide advanced Solar Water Pump Solutions designed to meet the irrigation and water supply needs of farmers, industries, and rural households. </p>
                  </div>
                  <div className="service-item-btn">
                    <Link to="/solar-water-pump-solution" className="readmore-btn">Learn More</Link>
                  </div>
                </div>
              </div>
              {/* Service Item End */}
            </div>
          </div>
        </div>
      </div>


    </>
  )
}

export default HomeServices